// ===============================================================
// 🔍 checkUserInFirestore.js — SERVER-FIRST (خطة "التسجيل")
// ✅ يسمح للفتاة بالدخول عند approved أو provisionally_approved
// ===============================================================

import { db, functions } from "../firebase";
import { httpsCallable } from "firebase/functions";
import { doc, getDoc } from "firebase/firestore";
import { getIdTokenResult } from "firebase/auth";
import { registerCurrentDevice } from "./deviceSecurity";

const ALLOWED_FEMALE_VERIFICATION_STATUSES = [
  "approved",
  "provisionally_approved",
];

function getClientCountryIso2() {
  return "";
}

export const checkUserInFirestore = async (user, navigate) => {
  try {
    if (!user?.uid) return;

    const ensureUserProfile = httpsCallable(functions, "ensureUserProfile");
    await ensureUserProfile({
      clientCountryIso2: getClientCountryIso2(),
    });

    await registerCurrentDevice();

    const ref = doc(db, "users", user.uid);
    const snap = await getDoc(ref);

    if (!snap.exists()) {
      navigate("/select-gender");
      return;
    }

    const data = snap.data() || {};

    if (data.accountStatus === "pending_delete") {
      navigate("/pending-delete");
      return;
    }

    if (data.accountStatus === "suspended") {
      navigate("/account-suspended", { replace: true });
      return;
    }

    if (!data.gender) {
      navigate("/select-gender");
      return;
    }

    const tokenResult = await getIdTokenResult(user);
    const isDeveloper = tokenResult?.claims?.developer === true;

    if (isDeveloper) {
      navigate("/home");
      return;
    }

    const verificationStatus = String(data.verificationStatus || "none");

    if (
      data.gender === "female" &&
      !ALLOWED_FEMALE_VERIFICATION_STATUSES.includes(verificationStatus)
    ) {
      navigate("/verification");
      return;
    }

    navigate("/home");
  } catch (err) {
    console.error("❌ checkUserInFirestore Error:", err);
    throw err;
  }
};